<template>
  <div class="add-pro-wrapper">
    <!-- 标题与保存按钮 -->
    <el-row>
      <el-col :span="12"><Title title="修改代理"></Title></el-col>
      <el-col :span="12">
        <div style="width:100%;height:60px;padding-right:15px;box-sizing:border-box" class="flex_rec">
          <el-button type="primary" @click="save">保存</el-button>
        </div>
      </el-col>
    </el-row>

    <div class="add-pro-content">
      <el-row :gutter="15">
      <!-- 左模块 -->
        <el-col :span="18">
          <!-- 基本信息 -->
          <el-card class="box-card">
            <el-row :gutter="20">
              <!-- 左边 -->
              <el-col :span="4">
                <div class="part-info">
                  <div class="title">基本</div>
                  <div class="info">代理信息</div>
                </div>
              </el-col>
              <!-- 右边 -->
              <el-col :span="20">
                <el-row :gutter="20">
                  <el-col :span="12">
                      <el-input placeholder="请输入内容" v-model="form.uuid" :disabled="true">
                        <template slot="prepend">uuid</template>
                      </el-input>
                  </el-col>
                  <el-col :span="12">
                      <el-input placeholder="请输入内容" v-model="form.username">
                        <template slot="prepend">用户名</template>
                      </el-input>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="mt10">
                  <el-col :span="24">
                      <el-input placeholder="请输入内容" v-model="form.password">
                        <template slot="prepend">密码</template>
                      </el-input>
                  </el-col>
                </el-row>

                <el-input
                  type="textarea"
                  style="margin-top:10px"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  placeholder="请输入内容"
                  v-model="form.comment">
                </el-input>
              </el-col>
            </el-row>
          </el-card>
          <!-- SKU额度 -->
          <el-card class="box-card">
            <el-row :gutter="20">
              <!-- 左边 -->
              <el-col :span="3">
                <div class="part-info">
                  <div class="title">SKU</div>
                  <div class="info">生成额度</div>
                </div>
              </el-col>
              <!-- 右边 -->
              <el-col :span="21">
                <el-button type="primary" icon="el-icon-plus" plain @click="dialogVisible1=true">添加代理可使用的 SKU</el-button>
                <el-table
                  :data="agent_sku_quota_list"
                  style="width: 100%">

                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-descriptions>
                          <el-descriptions-item label="SKU Key">{{props.row.sku_key}}</el-descriptions-item>
                          <el-descriptions-item label="套餐">{{props.row.plan_name}} / {{props.row.plan_key}}</el-descriptions-item>
                          <el-descriptions-item label="权益模式">{{props.row.plan_mode}}</el-descriptions-item>
                      </el-descriptions>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="sku_name"
                    label="SKU"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="time_limit"
                    label="激活时限"
                    width="100">
                    <template slot-scope="scope">{{timeLimitText(scope.row.time_limit)}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="platform"
                    label="平台"
                    width="100">
                    <template slot-scope="scope">{{platformLabel(scope.row.platform)}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="allow_device_num"
                    label="允许设备数"
                    width="90">
                    <template slot-scope="scope">{{deviceText(scope.row.allow_device_num)}}</template>
                  </el-table-column>
                  <el-table-column
                    prop="allow_create_code_num"
                    label="剩余额度"
                    width="80">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        icon="el-icon-edit"
                        circle
                        @click="handleEdit(scope.$index, scope.row)"></el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="handleDelete(scope.$index, scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>

        <!-- 右模块 -->
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>状态</span>
            </div>
            <p class="p-extra mb5">启用状态</p>
            <el-select v-model="form.status" placeholder="请选择账号状态" style="width:100%" class="mb10">
              <el-option
                v-for="item in status_arr"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 添加 SKU 额度 -->
    <el-dialog
      :append-to-body="true"
      title="选择可使用的 SKU"
      :visible.sync="dialogVisible1"
      width="30%">

        <el-form ref="dialogVisible1" :model="addAgentCodeTypeForm" label-width="80px">
          <el-form-item label="SKU">
            <el-select v-model="addAgentCodeTypeForm.sku_id_arr" multiple filterable placeholder="请选择">
                <el-option
                v-for="item in sku_list"
                :key="item.id"
                :label="skuOptionLabel(item)"
                :value="item.id">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="初始额度">
              <el-input-number v-model="addAgentCodeTypeForm.initial_num" :min="0" :max="9999" clearable></el-input-number>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="addDone1">确认添加</el-button>
      </span>
    </el-dialog>

    <!-- 修改 SKU 额度 -->
    <el-dialog
      :append-to-body="true"
      :title="'修改额度 '+editAgentCodeTypeForm.name"
      :visible.sync="dialogVisible2"
      width="30%">

        <el-form ref="dialogVisible2" :model="editAgentCodeTypeForm" label-width="100px">
          <el-form-item label="修改类型">
            <el-radio-group v-model="editAgentCodeTypeForm.update_type">
              <el-radio label="add">增加</el-radio>
              <el-radio label="reduce">减少</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="激活码数量">
              <el-input-number v-model="editAgentCodeTypeForm.num" :min="0" :max="9999" clearable></el-input-number>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="done2">确认修改</el-button>
      </span>
    </el-dialog>




  </div>
</template>

<script>
import Title from "./components/Title"
import apis from "@/api/index"
export default {
  name:'addProducts',
    components:{
      Title
    },
    data(){
      return{
        dialogVisible1:false,
        dialogVisible2:false,
        form:{},
        status_arr:[
          {name:'启用/激活',value:1},
          {name:'禁用/未激活',value:0},
        ],
        agent_sku_quota_list:[],
        addAgentCodeTypeForm:{sku_id_arr:[],initial_num:0},
        editAgentCodeTypeForm:{num:1,update_type:'add'},
        sku_list:[],
      }
    },
    methods:{
			confirm(ob,callback){
				this.$confirm(ob.msg, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: !ob.type?'warning':ob.type
				}).then(() => {
					callback()
				}).catch((e) => {
					console.error(e)
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
      save(){
        console.log(this.form)
        apis.agent.update(this.form).then(res=>{
          console.log('res',res)
          this.$router.push({name:'agentsList'})
        }).catch(err=>{
          this.$message({msg:err,type:'error'})
          console.log('err',err)
        })
      },
      readOne(){
        let p = this.$route.params.obj || {uuid:this.$route.query.uuid};
        if(!p.uuid) return;
        console.log(p)
        apis.agent.readOne({uuid:p.uuid}).then(res=>{
          console.log('res',res)
          // this.form_loading = false;
          this.form = res.data.data
        }).catch(err=>{
          this.form_loading = false;
          console.log('err',err)
        })
      },
      ReadOneAgentCodeType(){
        let p = this.$route.params.obj || {uuid:this.$route.query.uuid};
        if(!p.uuid) return;
        apis.agent_activation_quota.readByAgent({agent_uuid:p.uuid}).then(res=>{
          console.log('res',res)
          this.agent_sku_quota_list = res.data.data
        }).catch(err=>{
          this.form_loading = false;
          console.log('err',err)
        })
      },
      addDone1(){
        this.addAgentCodeTypeForm.agent_uuid = this.form.uuid;
        apis.agent_activation_quota.add(this.addAgentCodeTypeForm).then(res=>{
          this.$message({message:res.data.msg,type:'success'})
          this.ReadOneAgentCodeType();
          this.dialogVisible1 = false
          this.addAgentCodeTypeForm = {sku_id_arr:[], initial_num:0}
        }).catch(err=>{
          this.$message({message:err,type:'error'})
          this.dialogVisible1 = false
          console.log('err',err)
        })
      },
      //选择修改代理 SKU 额度
      handleEdit(index,row){
        this.dialogVisible2=true;
        Object.assign(this.editAgentCodeTypeForm,{
          name:row.sku_name || row.sku_key,
          num:1,
          update_type:'add',
          quota_id:row.quota_id
        })
      },
      //选择删除代理 SKU 额度
      handleDelete(index,row){
        this.confirm({msg:'确认删除该 SKU 额度'},()=>{
            const param = {
              quota_id:row.quota_id
            }
            apis.agent_activation_quota.remove(param).then(res=>{
              this.$message({message:res.data.msg,type:'success'})
              this.ReadOneAgentCodeType();
            }).catch(err=>{
              this.$message({message:err,type:'error'})
              console.log('err',err)
            })
        })
      },
      //确认修改代理 SKU 额度
      done2(){
        apis.agent_activation_quota.change(this.editAgentCodeTypeForm).then(res=>{
          this.$message({message:res.data.msg,type:'success'})
          this.dialogVisible2=false;
          this.ReadOneAgentCodeType();
        }).catch(err=>{
          this.$message({message:err,type:'error'})
          this.dialogVisible2=false;
          console.log('err',err)
        })
      },
      getSkuList(){
        apis.activation_code.readSkus({}).then(res=>{
          this.sku_list = (res.data.data || [])
        }).catch(err=>{
          console.log('err',err)
        })
      },
      skuOptionLabel(item){
        return [
          item.sku_name || item.sku_key,
          this.platformLabel(item.platform),
          this.timeLimitText(item.time_limit),
          this.deviceText(item.allow_device_num),
          item.plan_key || ''
        ].filter(Boolean).join(' / ')
      },
      platformLabel(platform){
        const labels = {
          win32:'Windows',
          darwin:'macOS',
          android:'Android',
          ios:'iOS',
          all:'全平台'
        }
        return labels[platform] || platform
      },
      timeLimitText(timeLimit){
        const value = Number(timeLimit)
        if(value === 0) return '永久'
        if(value === 0.5) return '12小时'
        if(value === 30) return '1个月'
        if(value === 120) return '季度'
        if(value === 365) return '1年'
        return `${value}天`
      },
      deviceText(deviceNum){
        return `${Number(deviceNum)}台`
      },
    },
    mounted(){
      this.readOne();
      this.getSkuList();
      this.ReadOneAgentCodeType();
    },
    created(){
    },
    computed:{

    },
    watch:{
    }
}
</script>

<style lang="scss">
.add-pro-wrapper{
  .add-pro-content{
    box-sizing: border-box;
    width: 100%;
    padding:15px;
  }
  .box-card{
    margin-bottom:5px;
  }
  .part-info{
    // @include flex_ccc();
    // background: brown;
    .title{
      font-size: 18px;
      color:#333;
    }
    .info{
      font-size: 12px;
      color:#999;
    }
  }
}
</style>
